import React from 'react';
import { TableActionCell } from 'wix-style-react';
import { classes as BlackPopoverMenuClasses } from '../BlackPopoverMenu/BlackPopoverMenu.st.css';
import { classes } from './BlackTableActionCell.st.css';

const BlackTableActionCell = (props: any) => {
  return (
    <div className={classes.container}>
      <TableActionCell
        {...props}
        className={`${classes.root} ${BlackPopoverMenuClasses.root}`}
      />
    </div>
  );
};

export default BlackTableActionCell;
